'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fa_IR = require('../vc-pagination/locale/fa_IR');

var _fa_IR2 = _interopRequireDefault(_fa_IR);

var _fa_IR3 = require('../date-picker/locale/fa_IR');

var _fa_IR4 = _interopRequireDefault(_fa_IR3);

var _fa_IR5 = require('../time-picker/locale/fa_IR');

var _fa_IR6 = _interopRequireDefault(_fa_IR5);

var _fa_IR7 = require('../calendar/locale/fa_IR');

var _fa_IR8 = _interopRequireDefault(_fa_IR7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  locale: 'fa',
  Pagination: _fa_IR2['default'],
  DatePicker: _fa_IR4['default'],
  TimePicker: _fa_IR6['default'],
  Calendar: _fa_IR8['default'],
  Table: {
    filterTitle: 'منوی فیلتر',
    filterConfirm: 'تایید',
    filterReset: 'پاک کردن',
    selectAll: 'انتخاب صفحه‌ی کنونی',
    selectInvert: 'معکوس کردن انتخاب‌ها در صفحه ی کنونی'
  },
  Modal: {
    okText: 'تایید',
    cancelText: 'لغو',
    justOkText: 'تایید'
  },
  Popconfirm: {
    okText: 'تایید',
    cancelText: 'لغو'
  },
  Transfer: {
    searchPlaceholder: 'جستجو',
    itemUnit: '',
    itemsUnit: ''
  },
  Upload: {
    uploading: 'در حال آپلود...',
    removeFile: 'حذف فایل',
    uploadError: 'خطا در آپلود',
    previewFile: 'مشاهده‌ی فایل',
    downloadFile: 'دریافت فایل'
  },
  Empty: {
    description: 'داده‌ای موجود نیست'
  }
};